<div class="layout">
  <!-- SIDEBAR -->
  <aside class="sidebar" [ngClass]="{ 'sidebar-anpp': isAnpp, 'sidebar-vin': !isAnpp }">
    @for (item of items; track $index) {
      @if (!item.hide) {
        <ng-container *hasDomaine="item.domaines">
          <button
            *hasRole="item.roles"
            class="sidebar-item active"
            [ngClass]="{ 'active': activeItem === item, 'active-vin': activeItem === item && !isAnpp, 'active-anpp': activeItem === item && isAnpp }"
            (click)="navigate(item)">
            <fa-icon [icon]="item.icon"></fa-icon>
            <span>{{ item.label | translate }}</span>
          </button>
        </ng-container>
      }
    }
  </aside>
 
  <!-- SUB MENU -->
  @if (activeItem?.items?.length) {
    <div class="submenu-wrapper">
      <div
        class="submenu"
        [ngClass]="{
          'submenu-anpp': isAnpp,
          'submenu-vin': !isAnpp,
          'submenu-closed': !submenuOpen
        }">

        @for (item of activeItem.items; track item.label) {
          <a
            [routerLink]="buildRouterLink(item.routerLink)"
            class="submenu-link d-flex justify-content-between align-items-center"
            [ngClass]="{
              'active': isMenuItemActive(buildRouterLink(item.routerLink))
            }">

            <span
              [ngClass]="isMenuItemActive(buildRouterLink(item.routerLink)) ? 'w-75' : 'w-100'">
              {{ item.label | translate }}
            </span>

            @if (isMenuItemActive(buildRouterLink(item.routerLink))) {
              <i class="pi pi-arrow-right"></i>
            }
          </a>
        }

      </div>

      <button
        class="submenu-toggle"
        [ngClass]="{
          'submenu-toggle-anpp': isAnpp,
          'submenu-toggle-vin': !isAnpp
        }"
        (click)="toggleSubmenu()">

        <i
          class="pi"
          [ngClass]="submenuOpen ? 'pi-chevron-left' : 'pi-chevron-right'">
        </i>
      </button>
    </div>
  }
</div>
